import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link", "bar"]

  connect() {
    this.sections = []
    this.linkTargets.forEach(link => {
      const id = link.dataset.section
      const el = document.getElementById(id)
      if (el) this.sections.push({ id, el, link })
    })

    this.onScroll = this.updateActive.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.updateActive()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  navigate(event) {
    event.preventDefault()
    const id = event.currentTarget.dataset.section
    const el = document.getElementById(id)
    if (!el) return

    const navHeight = 64 + (this.hasBarTarget ? this.barTarget.offsetHeight : 48) + 16
    const top = el.getBoundingClientRect().top + window.scrollY - navHeight

    window.scrollTo({ top, behavior: "smooth" })
  }

  updateActive() {
    const navHeight = 64 + (this.hasBarTarget ? this.barTarget.offsetHeight : 48) + 24
    let current = null

    for (const section of this.sections) {
      const rect = section.el.getBoundingClientRect()
      if (rect.top <= navHeight) current = section
    }

    // Only touch the DOM when the active section actually changes, so we don't
    // re-run class updates and a smooth scrollIntoView on every scroll event.
    const currentId = current ? current.id : null
    if (currentId === this.lastActiveId) return
    this.lastActiveId = currentId

    this.sections.forEach(({ link }) => {
      link.classList.remove("bg-teal-600", "text-white", "shadow-sm")
      link.classList.add("text-slate-500", "hover:text-slate-900", "hover:bg-slate-100")
    })

    if (current) {
      current.link.classList.add("bg-teal-600", "text-white", "shadow-sm")
      current.link.classList.remove("text-slate-500", "hover:text-slate-900", "hover:bg-slate-100")

      // Scroll the active pill into view within the nav bar
      current.link.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" })
    }
  }
}
